// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"76171b54","120":"e713a083","294":"160cded9","374":"f140431c","680":"b968651a","985":"b1967d49"}[chunkId] + ".chunk.js";
};